import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { theme } from './Themes'
import App from './App'
import './index.css'
import { Store } from './Store/Store'
import { Provider } from 'react-redux'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { SilentRenew } from './Auth/SilentRenew'
import { SigninCallback } from './Auth/SigninCallback'

ReactDOM.render(
  <Provider store={Store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          <Route exact={true} path="/silent-renew" component={SilentRenew} />
          <Route exact={true} path="/signin-callback" component={SigninCallback} />
          <Route path="/" component={App} />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
